import { create } from "zustand";
import { clearPlatformActivity, touchPlatformActivity } from "@/lib/platform-session-activity";

/** MT-1 AUTH-009: the platform account (never a school user: no tenant, no role). */
export type PlatformUser = { id: string; email: string };

type PlatformAuthState = {
  accessToken: string | null;
  user: PlatformUser | null;
  isAuthenticated: boolean;
  /** A platform sign-in: a fresh platform idle clock. */
  setSession: (accessToken: string, user: PlatformUser) => void;
  /** A platform token refresh: not activity. */
  renewSession: (accessToken: string, user: PlatformUser) => void;
  clearSession: () => void;
};

/**
 * MT-1 AUTH-009 (FR-6.6): the platform session, apart from the school one (`authStore`). The
 * access token is kept in memory only — never in localStorage — and a reload restores it from the
 * `lms_platform_refresh` cookie (`Path=/api/platform`). Nothing here reads or writes the school
 * store, its token or its idle clock.
 */
export const usePlatformAuthStore = create<PlatformAuthState>()((set) => ({
  accessToken: null,
  user: null,
  isAuthenticated: false,
  setSession: (accessToken, user) => {
    touchPlatformActivity(Date.now(), { force: true });
    set({ accessToken, user, isAuthenticated: true });
  },
  renewSession: (accessToken, user) => set({ accessToken, user, isAuthenticated: true }),
  clearSession: () => {
    clearPlatformActivity();
    set({ accessToken: null, user: null, isAuthenticated: false });
  },
}));
